import React, { useState } from 'react';
import { Check, X, AlertCircle, Save } from 'lucide-react';

const HybridApprovalModal = ({ workflow, onApprove, onClose }) => {
    const [editedPayload, setEditedPayload] = useState(JSON.stringify(workflow.payload, null, 2));

    const handleSave = () => {
        try {
            const parsed = JSON.parse(editedPayload);
            onApprove(parsed);
        } catch (e) {
            alert("Invalid JSON payload. Please check your syntax.");
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-6 animate-in fade-in duration-300">
            <div className="bg-white rounded-[2.5rem] w-full max-w-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300 flex flex-col max-h-[90vh]">
                {/* Header */}
                <div className="p-8 pb-4 flex items-center justify-between border-b border-slate-100">
                    <div className="flex items-center gap-3">
                        <div className="p-2 bg-blue-100 text-blue-600 rounded-xl">
                            <AlertCircle size={24} />
                        </div>
                        <div>
                            <h3 className="text-xl font-black text-slate-800 uppercase tracking-tight">Hybrid Approval</h3>
                            <p className="text-slate-500 text-xs font-medium">Review and refine agent-proposed changes</p>
                        </div>
                    </div>
                    <button onClick={onClose} className="p-2 text-slate-400 hover:text-slate-600 transition-colors rounded-full hover:bg-slate-100">
                        <X size={24} />
                    </button>
                </div>{/* Body */}
                <div className="p-8 overflow-y-auto flex-1">
                    <div className="mb-6 p-4 bg-blue-50 border border-blue-100 rounded-2xl flex gap-3">
                        <div className="text-blue-500"><AlertCircle size={20} /></div>
                        <p className="text-blue-700 text-sm font-medium leading-relaxed">
                            {workflow.notes || "The agent has prepared a draft for this workflow. Please review the payload below and make any necessary adjustments before approving."}
                        </p>
                    </div>

                    <div className="space-y-4">
                        <label className="text-sm font-black text-slate-500 uppercase tracking-wider pl-1">Proposed Payload</label>
                        <textarea
                            value={editedPayload}
                            onChange={(e) => setEditedPayload(e.target.value)}
                            className="w-full h-64 p-4 font-mono text-xs bg-slate-900 text-blue-300 rounded-2xl border-none focus:ring-2 focus:ring-blue-500 transition-all outline-none shadow-inner"
                            spellCheck="false"
                        />
                    </div></div>

                {/* Footer */}
                <div className="p-8 pt-4 flex items-center justify-end gap-3 border-t border-slate-100 bg-slate-50/50">
                    <button
                        onClick={onClose}
                        className="px-6 py-3 text-slate-500 font-bold text-xs uppercase tracking-widest hover:text-slate-700 transition-colors"
                    >
                        Discard
                    </button>
                    <button
                        onClick={handleSave}
                        className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-black text-xs uppercase tracking-widest transition-all active:scale-95 shadow-lg shadow-blue-200 flex items-center gap-2"
                    >
                        <Save size={16} />
                        Approve & Execute
                    </button>
                </div>
            </div></div>);
};

export default HybridApprovalModal;
